import { domContentLoadEvent } from '../common/domContentLoadEvent';

function setMenu() {
    const body = document.querySelector('body');

    document.querySelectorAll('header .btn-menu').forEach(function (button) {
        button.addEventListener('click', function () {
            body.classList.toggle('is-menu-open');
        });
    });

    const submenus = document.querySelectorAll('header .categories');
    submenus.forEach((submenu) => {
        const allCategories = submenu.querySelectorAll('.categorie');
        const allTabsLink = submenu.querySelectorAll('.btnFilterSubMenu');
        allTabsLink.forEach((link) => {
            link.addEventListener('click', () => {
                const idCategory = link.dataset.category;

                allTabsLink.forEach((linkRemove) => {
                    linkRemove.classList.remove('active');
                });
                allCategories.forEach((category) => {
                    category.classList.remove('active');
                });

                link.classList.add('active');
                submenu.querySelector('#categorie-' + idCategory).classList.add('active');
            });
        });
    });
}

domContentLoadEvent(setMenu);

import 'swiper/css';
export default class SubMenuModule {
    constructor() {
        this.sections = document.querySelectorAll('.submenu.categories');
        if (this.sections.length > 0) {
            this.ready();
        }
    }

    ready() {
        this.sections.forEach((section) => {});
    }
}

if (document.querySelector('.submenu')) {
    try {
        new SubMenuModule();
    } catch (e) {}
}
